__turbopack_context__.v({
  "buttonClose": "MZKqjq_buttonClose",
  "container": "MZKqjq_container",
  "isFirst": "MZKqjq_isFirst",
  "isTop": "MZKqjq_isTop",
  "mask": "MZKqjq_mask",
});
